import { consoleMsg, waitForContent } from "../shared/utility";
import { initializePage } from "../shared/page-init";
import { validatePage } from "../shared/validation";
import { previous } from "../shared/navigation";
import { storeDamageMarkers, restoreDamageMarkers } from "../shared/damage-map";
import { MarkerManager } from "../classes/marker-manager";
import { damageMgr } from "../web-components";
import { renderNavButtons } from "../shared/templates.js";

const app = window.app;

// This class might move to default and get exposed for all vendors
export class MbInterior extends HTMLElement {
	async connectedCallback() {
		await waitForContent("mbInterior");

		this.innerHTML = app.content.mbInterior;

		// Render the navigation buttons component
		this.querySelector("#nav-slot").replaceWith(renderNavButtons("backButton11", "nextButton11"));
		this.addEventListener("ionViewWillEnter", async () => {
			consoleMsg("ENTERING MERCEDES PAGES...");
			const pageElement = this;
			await initializePage(11, pageElement);
		});

		this.addEventListener("ionViewDidEnter", async () => {
			// Next/previous come from the flow manager — no vendor/direction logic needed.
			const currentRoute = app.routes.mbInterior;
			const nextPage = app.flowManager.getNext(currentRoute);
			const prevPage = app.flowManager.getPrevious(currentRoute);

			app.state.backButton.addEventListener("click", () => storeDamageMarkers(app.state.damageMarkers));
			if (prevPage) app.state.backButton.addEventListener("click", () => previous(prevPage.route));
			if (nextPage) app.state.nextButton.addEventListener("click", () => validatePage(nextPage.route));

			// Resolve damageAlert11 within THIS page element; create if missing (prod-safe)
			let damageAlert11 = this.querySelector("#damageAlert11");

			if (!damageAlert11) {
				console.error("damageAlert11 not found in page template");
				return; // or throw
			}

			await restoreDamageMarkers("myMap11", "interior");

			const interiorManager = new MarkerManager("myMap11", "interior", "damageAlert11", "removeMarkerButton11");
			interiorManager.updateRemoveButtonState();

			const myMap11 = document.getElementById("myMap11");
			if (myMap11) {
				myMap11.addEventListener("click", interiorManager.mapClicked.bind(interiorManager));
			}

			// Keep your inputs definition
			damageAlert11.inputs = [
				{ label: "Scrape", type: "radio", value: "scrape", checked: true },
				{ label: "Scratch", type: "radio", value: "scratch" },
				{ label: "Dent", type: "radio", value: "dent" },
				{ label: "Broken", type: "radio", value: "broken" },
				{ label: "Missing", type: "radio", value: "missing" },
				{ label: "Stained", type: "radio", value: "stained" },
			];

			// Keep your buttons definition, but fix the OK handler to match MarkerManager’s contract
			damageAlert11.buttons = [
				{
					text: "Cancel",
					role: "cancel",
					id: "damage-cancel",
					handler: () => {
						consoleMsg("Alert canceled");
						damageAlert11.dismiss();
						resetDialogState();
					},
				},
				{
					text: "OK",
					role: "confirm",
					id: "damage-ok",
					// IMPORTANT: set the correct data key and place marker now
					handler: (alertData) => {
						app.content.damageAlert11Data = alertData;
						consoleMsg("Selected value: " + alertData);
						try {
							interiorManager.addMarkerFromDialog();
						} catch (e) {
							console.error(e);
						}
						setTimeout(() => {
							damageAlert11.dismiss();
						}, 100);
						return { confirm: true };
					},
				},
			];

			// Ensure MarkerManager presents THIS alert instance (not a stale/global lookup)
			const resolvedDamageAlert11 = damageAlert11;
			const originalShowDamageDialog11 = interiorManager.showDamageDialog?.bind(interiorManager);
			interiorManager.showDamageDialog = function () {
				if (resolvedDamageAlert11 && typeof resolvedDamageAlert11.present === "function") {
					resolvedDamageAlert11.present();
				} else if (originalShowDamageDialog11) {
					originalShowDamageDialog11();
				}
			};

			//prettier-ignore
			damageAlert11.addEventListener("ionAlertDidDismiss", (event) => 
				consoleMsg(`Dismissed with role: ${event.detail.role}`),
			{ once: true });

			// Support either the correct 11-suffixed id or the older 2-suffixed id
			const removeMarkerButton = document.getElementById("removeMarkerButton11") || document.getElementById("removeMarkerButton2");
			if (removeMarkerButton) {
				removeMarkerButton.addEventListener("click", () => interiorManager.removeLastMarker());
			}

			/* --- NEW: issueTextAlert11 handling (mirrors page 2) --- */
			const issueTextAlert11 = document.getElementById("issueTextAlert11");
			if (issueTextAlert11 && !issueTextAlert11.dataset.hydratedButtons) {
				const buttonsAttr = issueTextAlert11.getAttribute("buttons");
				if (buttonsAttr) issueTextAlert11.buttons = JSON.parse(buttonsAttr);
				issueTextAlert11.dataset.hydratedButtons = "1";
			}

			if (issueTextAlert11) {
				issueTextAlert11.addEventListener("ionAlertDidDismiss", (ev) => {
					const role = ev.detail.role;
					const { textId, divId, textArea } = issueTextAlert11.data || {};

					if (role === "confirm") {
						// delete any photos first
						if (divId) {
							const photos = document.querySelectorAll(`#${divId} img`);
							if (photos.length > 0) {
								const deleteBtns = document.querySelectorAll(`#${divId} ion-button[id^="interiorDeletePhotoButton"]`);
								deleteBtns.forEach((btn) => btn.click());
							}
						}

						// clear issue text and mark as deleted
						const issueTextArea = textArea || (textId ? document.getElementById(textId) : null);
						if (issueTextArea && issueTextArea.value) {
							issueTextArea.value = "";
							const deletionMarkerKey = `${textId}-issueTextDeleted`;
							localStorage.setItem(deletionMarkerKey, "true");
						}

						// hide the associated div
						if (divId) hideDiv(divId);
					} else if (role === "cancel") {
						// revert radio back to Issue and keep region visible
						const radioGroup = document.querySelector("ion-radio-group");
						if (radioGroup) {
							radioGroup.value = "Issue";
							radioGroup.dispatchEvent(new Event("ionChange"));
						}
						if (divId) showDiv(divId);
					}
				});
			}

			damageMgr.attachPhotoEventListeners(this, "interiorPhotoRow", "interiorTakePhotoButton", "interiorDeletePhotoButton");
		});
	}
}
